module.exports = __webpack_public_path__ + "media/src/assets/Images/Fucac-9c6d50fcdf244a65f56232920aba7249.svg";